;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Button from 'components/ui/Button';
import Link from 'components/ui/Link';
import EntryLink from 'components/ui/Link/EntryLink';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import styles from './BlockLocation.module.scss';

const logoMap = {
    Market: 'market',
    Creamery: 'creamery',
};

const Location = ({
    location,
    address,
    linkToGoogleMaps,
    linkToReservation,
    hours,
    descriptionLine1,
    descriptionLine2,
    descriptionLine3,
    contactName,
    contactEmail,
    contactNumber,
    customLink,
    logo,
}) => {
    return (
        <article
            className={cx(styles.locationCard, {
                [styles.market]: location === 'Market',
            })}
        >
            <div className={styles.column}>
                {location && !logo && (
                    <div className={styles.logoWrapper}>
                        <SvgIcon type={logoMap[location]} />
                    </div>
                )}
                {logo?.url && (
                    <div className={styles.logoWrapper}>
                        <img src={logo.url} alt="" />
                    </div>
                )}
                <Link className={styles.address} href={linkToGoogleMaps}>
                    <Text
                        baseTheme="bodySmall"
                        themes={{
                            large: 'bodyMedium',
                            xxLarge: 'bodyLarge',
                        }}
                    >
                        {address}
                    </Text>
                </Link>

                {linkToReservation && (
                    <Button
                        className={styles.reservationButton}
                        theme="outlinedBlue"
                        href={linkToReservation}
                    >
                        Make A Reservation
                    </Button>
                )}
            </div>
            <div className={styles.column}>
                <div className={styles.columnInner}>
                    <div className={styles.hoursWrapper}>
                        <Text
                            className={styles.hoursLabel}
                            baseTheme="labelLarge"
                        >
                            Hours
                        </Text>
                        <ul className={styles.hoursList}>
                            {hours?.map((timeSpan, idx) => (
                                <li key={idx}>
                                    <div className={styles.timeSpan}>
                                        <Text baseTheme="headingXSmall">
                                            {timeSpan.days}
                                        </Text>
                                        <Text baseTheme="headingXSmall">
                                            {timeSpan.hours}
                                        </Text>
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <Text baseTheme="bodyXSmall">
                            {descriptionLine1}
                            {descriptionLine2 && (
                                <>
                                    <br />
                                    {descriptionLine2}
                                </>
                            )}
                            {descriptionLine3 && (
                                <>
                                    <br />
                                    {descriptionLine3}
                                </>
                            )}
                        </Text>
                    </div>
                    <div className={styles.contactWrapper}>
                        <Text
                            className={styles.contactLabel}
                            baseTheme="labelLarge"
                        >
                            Contact
                        </Text>
                        <Text
                            className={styles.contactName}
                            baseTheme="headingXSmall"
                        >
                            {contactName}
                        </Text>
                        {contactEmail && (
                            <Link
                                className={styles.contactEmail}
                                href={`mailto:${contactEmail}`}
                            >
                                <Text baseTheme="headingXSmall">
                                    {contactEmail}
                                </Text>
                            </Link>
                        )}
                        <Link
                            className={styles.contactNumber}
                            href={`tel:${contactNumber}`}
                        >
                            <Text baseTheme="headingXSmall">
                                {contactNumber}
                            </Text>
                        </Link>
                        {customLink?.text && customLink?.link && (
                            <div className={styles.buttonWrapper}>
                                <EntryLink
                                    className={styles.customLink}
                                    entry={customLink.link}
                                >
                                    <Text baseTheme="headingXSmall">
                                        {customLink.text}
                                    </Text>
                                </EntryLink>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </article>
    );
};

Location.propTypes = {
    location: PropTypes.oneOf(['Market', 'Creamery']),
    logo: PropTypes.object,
    address: PropTypes.string,
    linkToGoogleMaps: PropTypes.string,
    linkToReservation: PropTypes.string,
    hours: PropTypes.array,
    descriptionLine1: PropTypes.string,
    descriptionLine2: PropTypes.string,
    descriptionLine3: PropTypes.string,
    linkToMenus: PropTypes.string,
    contactName: PropTypes.string,
    contactEmail: PropTypes.string,
    contactNumber: PropTypes.string,
    customLink: PropTypes.object,
    className: PropTypes.string,
};

export default Location;
